import { ReactNode, useCallback } from "react";

import { ChevronDown } from "components/icons/generated";
import Icon from "ds/components/Icon";

import styles from "./styles.module.css";

type RunCodeChangesExpandableHeaderProps = {
  isExpanded: boolean;
  onToggle: () => void;
  children: ReactNode;
};

const RunCodeChangesExpandableHeader = ({
  isExpanded,
  onToggle,
  children,
}: RunCodeChangesExpandableHeaderProps) => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.code === "Space" || e.code === "Enter") {
        e.preventDefault();
        onToggle();
      }
    },
    [onToggle]
  );

  return (
    <div
      className={styles.expandableHeader}
      onClick={onToggle}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-expanded={isExpanded}
    >
      <Icon src={ChevronDown} className={styles.chevron} rotate={isExpanded ? undefined : "270"} />
      {children}
    </div>
  );
};

export default RunCodeChangesExpandableHeader;
